import React, { useMemo } from "react";
import { MapPin } from "lucide-react";
import { Card, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "./ui/table";
import { EmptyState } from "./StateBlock";
import { formatNumber, sortRows } from "./d2cFormat";

const COLUMNS = [
  { key: "held", label: "Held" },
  { key: "offered", label: "Offered" },
  { key: "accepted", label: "Accepted" },
  { key: "delivered", label: "Delivered" },
];

// Held, offered, accepted and delivered per OMS region, from summary.regions.
// A null region_id is an order whose state has no region on file.
const RegionTable = ({ regions }) => {
  const rows = useMemo(() => sortRows(regions, "held", "desc"), [regions]);

  return (
    <Card>
      <CardHeader>
        <div>
          <CardTitle>By region</CardTitle>
          <CardDescription>Most held orders first.</CardDescription>
        </div>
      </CardHeader>
      {rows.length ? (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Region</TableHead>
              {COLUMNS.map((column) => (
                <TableHead key={column.key} className="tw-text-right">
                  {column.label}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.region_id || "none"} className="hover:tw-bg-muted/40">
                <TableCell className="tw-font-medium">
                  {row.name || (row.region_id ? "Unnamed region" : "No region on file")}
                </TableCell>
                {COLUMNS.map((column) => (
                  <TableCell key={column.key} className="tw-text-right tw-tabular-nums">
                    {formatNumber(row[column.key])}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        <EmptyState icon={MapPin}>No held orders in this range.</EmptyState>
      )}
    </Card>
  );
};

export default RegionTable;
